var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 20L27.7071 19.2929L28.4142 20L27.7071 20.7071L27 20ZM12 21C11.4477 21 11 20.5523 11 20C11 19.4477 11.4477 19 12 19V21ZM21.7071 13.2929L27.7071 19.2929L26.2929 20.7071L20.2929 14.7071L21.7071 13.2929ZM27.7071 20.7071L21.7071 26.7071L20.2929 25.2929L26.2929 19.2929L27.7071 20.7071ZM27 21H12V19H27V21Z",
    fill: "#565D70"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.5,
    stroke: "#565D70",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowRight);
export default __webpack_public_path__ + "static/media/circle-arrow-right.f049382ffccc27ca28b4c0675fe4a2ad.svg";
export { ForwardRef as ReactComponent };